export default function checkProfanity(value, badWords) {
  const formattedValue = formatString(value);
  return badWords?.some?.((w) => {
    const formattedWord = formatString(w);
    return formattedValue.includes(formattedWord);
  });
}

function formatString(string) {
  return string?.toLowerCase?.()?.replaceAll?.(' ', '');
}
